var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5375 0.338998L4.18414 8.87458L1.96747 6.36702C1.55914 5.95939 0.917473 5.93468 0.450807 6.28055C-0.00419316 6.63877 -0.132527 7.26875 0.147473 7.7752L2.77247 12.2962C3.02914 12.7162 3.47247 12.9756 3.97414 12.9756C4.45247 12.9756 4.90747 12.7162 5.16414 12.2962C5.58414 11.7157 13.5991 1.59895 13.5991 1.59895C14.6491 0.462523 13.3775 -0.538029 12.5375 0.326646V0.338998Z",
    fill: "#0057D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolCheck);
export default __webpack_public_path__ + "static/media/sol-check.74def087468baa51dbe66375c795c925.svg";
export { ForwardRef as ReactComponent };